import { useCallback } from "react";

export function useScrollItemIntoCenter(listRef) {
  const scrollItemIntoCenter = useCallback(
    element => {
      if (!listRef.current || !element) return;

      const parent = listRef.current;
      const parentRect = parent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const offset =
        elementRect.left -
        parentRect.left -
        parent.clientWidth / 2 +
        elementRect.width / 2;

      parent.scrollBy({ left: offset, behavior: "smooth" });
    },
    [listRef]
  );

  return scrollItemIntoCenter;
}
